<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template #activator="{ on }">
      <v-chip
        :close="Boolean(value)"
        class="mr-2 mb-2"
        outlined
        v-on="on"
        @click:close="$emit('clear')"
      >
        <v-icon
          class="mr-1"
          small
        >
          {{ Boolean(value) ? 'mdi-pencil' : 'mdi-plus' }}
        </v-icon>
        {{ text }}
        <template v-if="Boolean(value)">
          <v-divider
            class="mx-2"
            vertical
          />
          <span>{{ value }}</span>
        </template>
      </v-chip>
    </template>
    <v-card class="pa-8">
      <slot
        name="form"
        :hide="hideForm"
      />
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'DataIteratorFiltersChip',
  props: {
    text: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    menu: false,
  }),
  methods: {
    hideForm() {
      this.menu = false;
    },
  },
};
</script>
